import React from "react";
import { cn } from "../../lib/cn";

/**
 * Label + control wrapper. Use `kicker` for the mono/uppercase auth-style label;
 * default is a clean medium label suited to dense forms.
 *   <FormField label="Email" required error={err}><Input .../></FormField>
 */
export function FormField({ label, htmlFor, required, error, hint, kicker = false, className, children }) {
  return (
    <div className={cn("space-y-2", className)}>
      {label && (
        <label
          htmlFor={htmlFor}
          className={cn(
            "block",
            kicker
              ? "font-mono text-[0.66rem] uppercase tracking-kicker text-muted"
              : "text-[0.82rem] font-semibold text-ink"
          )}
        >
          {label}
          {required && <span className="ml-1 text-danger">*</span>}
        </label>
      )}
      {children}
      {error ? (
        <p className="text-xs font-medium text-danger">{error}</p>
      ) : hint ? (
        <p className="text-xs text-muted">{hint}</p>
      ) : null}
    </div>
  );
}

export default FormField;
